/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IVisitable } from '../IVisitable';
import { INamed } from './INamed';

/**
 * Any node model that represents a re-usable definition.  Examples include
 * Schema Definitions, Parameter Definitions, etc.
 * 
 * Any class implementing this interface MUST have {@link io.apicurio.datamodels.core.models.Node} as it's supertype.
 * 
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IDefinition extends INamed, IVisitable {}


